<script>
    import SmartTable from "Components/SmartTable";
    export default {
        extends: SmartTable,
        data: () => ({
            title: 'Clienti',
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Nume', value: 'name' },
                { text: 'Telefon', value: 'phone' },
                { text: 'Sediu', value: 'full_address', sortable: false },
                { text: 'Data inregistrarii', value: 'created_at' },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            items: [],
            meta: {
                pagination: {
                    count: 0,
                    current_page: 0,
                    per_page: 0,
                    total: 0,
                    total_pages: 0
                }
            },
            options: {
                sortBy: ['id'],
                sortDesc: [true]
            },
            editedIndex: -1,
            showTrashedCheckbox: true,
            showTrashed: false
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
        },

        watch: {
            showTrashed: {
                handler(val) {
                    this.initialize()
                }
            },
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        async created () {
            await this.initialize()
        },

        methods: {
            async initialize () {
                this.loading = true
                var query = this.$db.Customer
                    .append('full_address')
                    .orderBy(this.orderBy)
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                if(this.showTrashed) query = query.where('onlyTrashed', true)
                let { data, meta } = await query.get()
                this.items = data
                this.meta = meta
                this.loading = false
            },

            editItem (item) {
                this.$router.push({ name: 'customers-edit', params: { id: item.id } })
            },

            deleteItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            async deleteItemConfirm () {
                let item = this.items[this.editedIndex]
                if(item instanceof this.$db.Customer) {
                    await item.delete().catch((err) => {
                        this.showError(err?.response?.data?.error)
                        throw err
                    })
                } else {
                    console.warn('Here comes the headache...')
                }
                this.dialogDelete = false
                await this.initialize()
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            save () {
            },

            addNewItem: function() {
                this.$router.push({ name: 'customers-create' })
            }
        },
    };
</script>
